$shm_hitalama_profile_switch $mol_view
	profile null $shm_hitalama_profile
	align \bottom_left
	sub /
		<= Login $mol_link
			title <= login \
			hint \Личный кабинет
			arg * section \profile
	buttons /
		<= Enter_link $mol_link
			title \Войти
			uri \/login
		<= Register_link $mol_link
			title \Регистрация
			uri \/login
